// extracted by css-extract-rspack-plugin
export default {"commentsMenu":"IWu81","visible":"zt7cw"};